import { render, staticRenderFns } from "./MoneyRelease.vue?vue&type=template&id=12f5c82a&scoped=true"
import script from "./MoneyRelease.vue?vue&type=script&lang=js"
export * from "./MoneyRelease.vue?vue&type=script&lang=js"
import style0 from "./MoneyRelease.vue?vue&type=style&index=0&id=12f5c82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5c82a",
  null
  
)

export default component.exports